import React, { useEffect, useMemo, useState } from "react";
import api, { API } from "@/lib/api";
import { PageHeader, Card, Button, Input, Select, Field, Stat, Textarea } from "@/components/UI";
import { Plus, PencilSimple, Trash, ForkKnife, ArrowCounterClockwise, ChefHat, Book, FileXls, Printer } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { today, fmt, rid, EMPTY_RATION, EMPTY_CAT } from "./constants";

export function CatalogTab({ catalog, reload }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(EMPTY_CAT);
  const [editId, setEditId] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const body = {
      ...form,
      protein_pct: Number(form.protein_pct || 0),
      energy_mcal: Number(form.energy_mcal || 0),
    };
    try {
      if (editId) { await api.patch(`/feed-catalog/${editId}`, body); toast.success("Yem güncellendi"); }
      else { await api.post("/feed-catalog", body); toast.success("Yem eklendi"); }
      setForm(EMPTY_CAT); setEditId(null); setShowForm(false); reload();
    } catch (err) { toast.error(err?.message || "Hata"); }
  };

  const startEdit = (c) => {
    setEditId(c.id);
    setForm({ name: c.name, category: c.category, protein_pct: c.protein_pct, energy_mcal: c.energy_mcal, notes: c.notes || "" });
    setShowForm(true);
  };
  const del = async (c) => {
    if (!window.confirm(`"${c.name}" katalogdan silinsin mi?`)) return;
    try { await api.delete(`/feed-catalog/${c.id}`); toast.success("Silindi"); reload(); }
    catch (err) { toast.error(err?.message || "Hata"); }
  };

  return (
    <Card>
      <div className="flex items-center justify-between mb-3">
        <h3 className="heading text-lg">Yem Kataloğu <span className="text-xs text-[#8a938c] font-normal">— standart yem tanımları (protein/enerji)</span></h3>
        <Button data-testid="catalog-add-btn" onClick={() => { setEditId(null); setForm(EMPTY_CAT); setShowForm(v => !v); }}>
          <Plus size={14} className="inline mr-1" /> {showForm ? "İptal" : "Yeni Yem"}
        </Button>
      </div>
      {showForm && (
        <form onSubmit={submit} className="grid md:grid-cols-2 gap-3 mb-4 p-4 bg-[#F5F2EC] rounded">
          <Field label="Yem Adı *"><Input required data-testid="catalog-name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></Field>
          <Field label="Kategori">
            <Select data-testid="catalog-category" value={form.category} onChange={e => setForm({...form, category: e.target.value})}>
              <option value="kaba yem">kaba yem</option>
              <option value="konsantre">konsantre</option>
              <option value="katkı">katkı</option>
              <option value="diğer">diğer</option>
            </Select>
          </Field>
          <Field label="Protein %"><Input type="number" step="0.1" min="0" max="100" data-testid="catalog-protein" value={form.protein_pct} onChange={e => setForm({...form, protein_pct: e.target.value})} /></Field>
          <Field label="Enerji (Mcal/kg)"><Input type="number" step="0.1" min="0" data-testid="catalog-energy" value={form.energy_mcal} onChange={e => setForm({...form, energy_mcal: e.target.value})} /></Field>
          <div className="md:col-span-2">
            <Field label="Notlar"><Input value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} /></Field>
          </div>
          <div className="md:col-span-2 flex gap-2">
            <Button type="submit">{editId ? "Güncelle" : "Ekle"}</Button>
            <Button type="button" onClick={() => { setShowForm(false); setEditId(null); }} className="!bg-white !text-[#1A1D1A] border border-[#E5E2DC]">Vazgeç</Button>
          </div>
        </form>
      )}
      <table className="data-table">
        <thead><tr><th>Yem</th><th>Kategori</th><th className="text-right">Protein</th><th className="text-right">Enerji</th><th>Notlar</th><th></th></tr></thead>
        <tbody>
          {catalog.map(c => (
            <tr key={c.id} data-testid={`catalog-row-${c.id}`}>
              <td className="font-semibold">{c.name}</td>
              <td><span className="text-xs bg-[#F5F2EC] px-2 py-0.5 rounded">{c.category}</span></td>
              <td className="text-right tabnum">%{fmt(c.protein_pct, 1)}</td>
              <td className="text-right tabnum">{fmt(c.energy_mcal, 1)} Mcal/kg</td>
              <td className="text-xs text-[#6b746c]">{c.notes || "—"}</td>
              <td className="text-right whitespace-nowrap">
                <button onClick={() => startEdit(c)} className="p-1.5 hover:bg-[#f2ede4] rounded"><PencilSimple size={16} /></button>
                <button onClick={() => del(c)} className="p-1.5 hover:bg-[#fbeee9] text-[#C45B45] rounded ml-1"><Trash size={16} /></button>
              </td>
            </tr>
          ))}
          {!catalog.length && <tr><td colSpan={6} className="text-center py-8 text-[#8a938c]">Katalog boş</td></tr>}
        </tbody>
      </table>
    </Card>
  );
}
